/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_STATEMENT_LIST (state, val) {
    state.statementList = val
  },
  UPDATE_STATEMENT_LIST (state, val) {
    state.statementList.push(...val)
  },
  ADD_STATEMENT(state, statement) {
    state.statementList.unshift(statement)
  },
  UPDATE_STATEMENT (state, statement) {        
    const i = state.statementList.findIndex((e) => e.id == statement.id)
    Object.assign(state.statementList[i], statement)
  },
  DELETE_STATEMENT(state, statement) {
    const i = state.statementList.findIndex((e) => e.id == statement.id)
    state.statementList.splice(i, 1)
  }
}
